module.exports = __webpack_public_path__ + "2fa67ba87798499e868568df4ef9c9a7.jpg";